@if (isEdit) {
  <div class="mb-3 rounded bg-surface-100 px-3 py-2">
    {{ selection[0]?.label ?? '' }}
  </div>
} @else {
  <p-tree
    [(selection)]="selection"
    [ariaLabel]="'CHOP.MASSNAHMEN' | translate"
    [filter]="true"
    [value]="treeNodes"
    [virtualScroll]="true"
    [virtualScrollItemSize]="36"
    class="mb-3 block"
    filterBy="label"
    scrollHeight="55vh"
    selectionMode="checkbox"></p-tree>
}
@if (form) {
  <form (ngSubmit)="onSubmit()" [formGroup]="form" class="grid grid-cols-12 gap-2" novalidate>
    <app-form-number-input
      [form]="form"
      [min]="0"
      [twoColumns]="true"
      id="maximalAnzahl"
      label="CHOP.MAXIMAL_ANZAHL"></app-form-number-input>
    <app-form-number-input
      [form]="form"
      [min]="0"
      [twoColumns]="true"
      id="mindestAnzahl"
      label="CHOP.MINDEST_ANZAHL"></app-form-number-input>
  </form>
}
<div class="mt-4 flex justify-end gap-2">
  <p-button
    (onClick)="cancel()"
    [label]="'ACTIONS.CANCEL' | translate"
    [outlined]="true"
    severity="secondary"></p-button>
  <p-button
    (onClick)="onSubmit()"
    [disabled]="submitting || (!isEdit && selection.length === 0)"
    [label]="'ACTIONS.SAVE' | translate"></p-button>
</div>
